
import { h, Fragment } from 'preact'
import { Instagram, Facebook, LinkedIn, Twitter, YouTube } from '@components/icons'
import ImageLoad from '@components/image-load'

import './style.less'


// Shorten a string to less than maxLen characters without truncating words.
// adapted from from: https://stackoverflow.com/a/40382963
const shorten = (str, maxLen = 120, separator = ' ') => {
  	if (str.length <= maxLen) return str;
	const string = str.substr(0, str.lastIndexOf(separator, maxLen)).replace(/[^a-z]$/i, '')
  	return `${string}…`;
}


export default ({ image, href, date, text, username, userurl }) => {

	const Component = href ? 'a' : 'div'

	return (
		<Component target={href ? '_blank' : undefined} href={href} class="post">
			<div className="post__bg">
				<ImageLoad {...image} />
			</div>
			<div className="post__overlay">
				<div class="post__overlay__bar">
					<div class="post__icon"><Instagram /></div>
					{username}
				</div>
				<div className="post__overlay__content">
					<p class="post__overlay__content__text">{shorten(text || '')}</p>
					{date && <p class="post__overlay__content__date">{date || ''}</p>}
				</div>
			</div>
		</Component>
	)
}
